/**
 * Regras de recomendacao (nao bloqueantes) de alocacao do objetivo.
 *
 * Espelha o subconjunto de Objetivo.incorreto (investidores/models/objetivo.py)
 * usado como aviso ao vivo nas telas de porcentagem — tanto no wizard de
 * criacao (AdicionarObjetivo.js) quanto no modal de edicao do objetivo ja
 * criado (ModalComplexoVue.js). Compartilhado para os dois nao divergirem
 * das mensagens/faixas do backend com o tempo.
 *
 * Cada aviso carrega uma `fase` semantica (nao um numero de step): wizard e
 * modal numeram suas telas de forma diferente, entao cada um mapeia seus
 * proprios steps para essas fases ao filtrar o que exibir.
 *
 * Fases possiveis: 'macro' (Renda Fixa x Variavel), 'exterior' (Brasil x
 * EUA), 'mix_br' (Acoes x FIIs), 'mix_eua' (Stocks x REITs).
 */

const parPreenchido = (campos, a, b) =>
	campos[a] !== "" &&
	campos[b] !== "" &&
	Math.round((Number(campos[a]) + Number(campos[b])) * 100) / 100 === 100;

export function calcularAvisosRecomendacao(campos_objetivo) {
	const c = campos_objetivo;
	const avisos = [];

	const noHaveRendaVariavel = c.pr_renda_variavel == 0;
	const noHaveBr = c.pr_renda_variavel_br == 0;
	const noHaveEUA = c.pr_renda_variavel_eua == 0;

	if (parPreenchido(c, "pr_renda_fixa", "pr_renda_variavel")) {
		const rf = Number(c.pr_renda_fixa);
		const rv = Number(c.pr_renda_variavel);
		if (rf < 20 || rf > 80) {
			avisos.push({
				fase: "macro",
				mensagem: `Atenção: Renda Fixa está em ${rf.toFixed(2)}%, fora da faixa recomendada (20% a 80%).`,
			});
		}
		if (rv < 20 || rv > 80) {
			avisos.push({
				fase: "macro",
				mensagem: `Atenção: Renda Variável está em ${rv.toFixed(2)}%, fora da faixa recomendada (20% a 80%).`,
			});
		}
	}

	const temRendaVariavel =
		parPreenchido(c, "pr_renda_fixa", "pr_renda_variavel") && !noHaveRendaVariavel;

	if (
		temRendaVariavel &&
		parPreenchido(c, "pr_renda_variavel_br", "pr_renda_variavel_eua")
	) {
		const eua = Number(c.pr_renda_variavel_eua);
		if (eua < 20 || eua > 40) {
			avisos.push({
				fase: "exterior",
				mensagem: `Atenção: o percentual no exterior (EUA) está em ${eua.toFixed(2)}%, fora da faixa recomendada (20% a 40%).`,
			});
		}
	}

	if (temRendaVariavel && !noHaveBr && parPreenchido(c, "pr_acoes", "pr_fiis")) {
		const acoes = Number(c.pr_acoes);
		const fiis = Number(c.pr_fiis);
		if (acoes < 30 || acoes > 70) {
			avisos.push({
				fase: "mix_br",
				mensagem: `Atenção: Ações está em ${acoes.toFixed(2)}%, fora da faixa recomendada (30% a 70%).`,
			});
		}
		if (fiis < 30 || fiis > 70) {
			avisos.push({
				fase: "mix_br",
				mensagem: `Atenção: FIIs está em ${fiis.toFixed(2)}%, fora da faixa recomendada (30% a 70%).`,
			});
		}
	}

	if (temRendaVariavel && !noHaveEUA && parPreenchido(c, "pr_stocks", "pr_reits")) {
		const stocks = Number(c.pr_stocks);
		const reits = Number(c.pr_reits);
		if (stocks < 30 || stocks > 70) {
			avisos.push({
				fase: "mix_eua",
				mensagem: `Atenção: Stocks está em ${stocks.toFixed(2)}%, fora da faixa recomendada (30% a 70%).`,
			});
		}
		if (reits < 30 || reits > 70) {
			avisos.push({
				fase: "mix_eua",
				mensagem: `Atenção: REITs está em ${reits.toFixed(2)}%, fora da faixa recomendada (30% a 70%).`,
			});
		}
	}

	return avisos;
}
